import { AccessTokenKey, RefreshTokenKey } from '../contexts/Authentication';
import Auth from './auth';

export const URLBuild = (base: string, params: any): string => {
  var url = new URL(base);

  Object.keys(params).forEach(key => {
    if (Array.isArray(params[key])) {
      params[key].forEach((val: string) => {
        url.searchParams.append(key + '[]', val);
      })
    } else {
      url.searchParams.append(key, params[key])
    }
  });

  return url.toString();
}

const Fetcher = {
  request: async (method: string, path: string, body: any = null, headers: any = {}, retry: number = 0): Promise<any> => {
    headers = Object.assign({}, headers, {
      Authorization: 'Bearer ' + localStorage.getItem(AccessTokenKey),
      'Content-Type': 'application/json'
    });

    return await fetch(path, { method, headers, body })
      .then(res => {
        if (res.status < 200 || res.status >= 300)
          throw res;
        return res.json();
      })
      .catch(err => {
        if (err.status === 401) {
          if (retry === 1) {
            localStorage.removeItem(RefreshTokenKey);
            localStorage.removeItem(AccessTokenKey);
          } else {
            return Auth.refresh()
              .then((res) => {if (!res) throw new Error('Unauthorized')})
              .then(() => Fetcher.request(method, path, body, headers, retry + 1));
          }
        }
        throw err;
      });
  },

  get: async (path: string, headers: any = {}): Promise<any> => Fetcher.request('GET', path, null, headers),
  post: async (path: string, data: any = {}, headers: any = {}): Promise<any> => Fetcher.request('POST', path, data, headers),
  put: async (path: string, data: any, headers: any = {}): Promise<any> => Fetcher.request('PUT', path, data, headers),
  patch: async (path: string, data: any, headers: any = {}): Promise<any> => Fetcher.request('PATCH', path, data, headers),
  delete: async (path: string, headers: any = {}): Promise<any> => Fetcher.request('DELETE', path, null, headers)
};

export default Fetcher;